import React from 'react'
import {Card} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'

const DigitalSigningCard = ({icon, stat, title}: {icon: string; stat: number; title: string}) => {
  const {formatMessage} = useIntl()
  return (
    <Card className='w-48 w-md-100 p-4'>
      <div className='d-flex align-items-center'>
        <div>
          <KTSVG path={icon} className='icon-size' />
        </div>
        <div className='pt-3 pb-2 ps-1'>
          <p className='font-size-24 font-weight-600 mb-0'>{stat}</p>
        </div>
      </div>
      <div>
        <p className='font-size-14 text-muted mb-0'>{formatMessage({id: title})}</p>
      </div>
    </Card>
  )
}

export default DigitalSigningCard
